import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Helmet from 'react-helmet';
import Actions from '../../store/ducks/auth';
import ChekingAuth from './CheckingAuth';
import Login from './Login';
import ProductError from './ProductError';

const SignIn = () => {
  const dispatch = useDispatch();
  const {
    auth: {
      access_token: accessToken,
      loading: { checkingAuth },
      isAuthenticated,
      keepConnected,
    },
    product,
  } = useSelector(state => state);
  const [productError, setProductError] = useState(null);
  const [checkAuthRequested, setCheckAuthRequested] = useState(false);

  useEffect(() => {
    if (accessToken && !checkingAuth && !isAuthenticated) {
      const credentials = { accessToken, keepConnected };
      dispatch(Actions.checkAuth(credentials));
      setCheckAuthRequested(true);
    }
  }, [
    accessToken,
    checkAuthRequested,
    isAuthenticated,
    dispatch,
    keepConnected,
    checkingAuth,
  ]);

  useEffect(() => {
    if (product.error) {
      setProductError(product.error);
    } else {
      setProductError(null);
    }
  }, [product.error]);

  return (
    <>
      <Helmet>
        <title>
          {!product.loadedConfigs && !productError
            ? 'Buscando informações...'
            : ''}
          {productError ? 'Erro ao carregar informações...' : ''}
          {checkingAuth && product.loadedConfigs ? 'Autenticando...' : ''}
          {!checkingAuth && product.loadedConfigs
            ? `Login - ${product.productName}`
            : ''}
        </title>
      </Helmet>
      {!!productError && <ProductError error={productError} />}
      {checkingAuth && !productError && <ChekingAuth />}
      {!checkingAuth && product.loadedConfigs && !productError && <Login />}
    </>
  );
};

export default SignIn;
